/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CCTicketPaymentCreate } from '../models/CCTicketPaymentCreate';
import type { CCTokenCreate } from '../models/CCTokenCreate';
import type { CCTokenDetails } from '../models/CCTokenDetails';
import type { CCTokenUpdate } from '../models/CCTokenUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { PaymentDetails } from '../models/PaymentDetails';
import type { PendingCCTokenStatus } from '../models/PendingCCTokenStatus';
import type { TokenPaymentCreate } from '../models/TokenPaymentCreate';
import { request as __request } from '../core/request';

export class CcTokensVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async ccTokensVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/cc/tokens/get`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns CCTokenDetails OK
     * @throws ApiError
     */
    public static async ccTokensVGetExport(
        requestBody?: PagingQuery,
    ): Promise<CCTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/cc/tokens/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param ccTokenId
     * @param requestBody
     * @returns CCTokenDetails OK
     * @throws ApiError
     */
    public static async ccTokensVUpdateCcToken(
        ccTokenId: string,
        requestBody?: CCTokenUpdate,
    ): Promise<CCTokenDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/cc/tokens/${ccTokenId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param ccTokenId
     * @param requestBody
     * @returns PaymentDetails OK
     * @throws ApiError
     */
    public static async ccTokensVCharge(
        ccTokenId: string,
        requestBody?: TokenPaymentCreate,
    ): Promise<PaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/cc/tokens/${ccTokenId}/charge`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns PaymentDetails OK
     * @throws ApiError
     */
    public static async ccTokensVChargeTicket(
        requestBody?: CCTicketPaymentCreate,
    ): Promise<PaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/cc/tokens/ticket_charge`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param pendingCcTokenId
     * @returns PendingCCTokenStatus OK
     * @throws ApiError
     */
    public static async ccTokensVGetPendingCcTokenStatus(
        pendingCcTokenId: string,
    ): Promise<PendingCCTokenStatus> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/cc/tokens/${pendingCcTokenId}/status`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns CCTokenDetails Created
     * @throws ApiError
     */
    public static async ccTokensVCreate(
        requestBody?: CCTokenCreate,
    ): Promise<CCTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/cc/tokens`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

}